import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.filtering');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import {
    cellyticsAnalysisDataUrl,
    cellyticsAnalysisSet,
    cellyticsCurrentAnalysisSetId,
    cellyticsDefaultAnalysisSet,
} from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};

@Component({
    selector: 'wiz-page-filtering',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.filtering/view.scss */
/* src/app/page.filtering/view.scss: no such file or directory */`],
})
export class PageFilteringComponent implements OnInit, OnDestroy {
    public analysis: any = null;
    public analysisSetId: string = "";
    public analysisSet: any = null;
    public loading: boolean = true;
    public error: string = "";
    public selectedSampleId: string = "";
    public selectedFilterCaseId: string = "mmd_filter";
    public selectedThreshold: number = 12.6;
    public imageModal: any = null;

    public comparisonRows: any[] = [
        { key: "finalCount", label: "최종 cell", digits: 0, source: "case" },
        { key: "mmdRejected", label: "MMD 제외", digits: 0, source: "case" },
        { key: "overlapRejected", label: "Overlap 제외", digits: 0, source: "case" },
        { key: "CMV", label: "CMV", digits: 2, source: "metrics" },
        { key: "PPD", label: "PPD", digits: 2, source: "metrics" },
        { key: "MMD", label: "MMD", digits: 2, source: "metrics" },
        { key: "MMD_SD", label: "MMD_STD", digits: 2, source: "metrics" },
        { key: "WCM", label: "WCM", digits: 2, source: "metrics" },
        { key: "WCM_SD", label: "WCM_STD", digits: 2, source: "metrics" },
        { key: "WSM", label: "WSM", digits: 2, source: "metrics" },
        { key: "WSM_SD", label: "WSM_STD", digits: 2, source: "metrics" },
        { key: "CSP", label: "CSP", digits: 2, source: "metrics" },
    ];

    private routerSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.hasAccess()) {
            location.href = "/access";
            return;
        }
        this.applyAccessSession();
        this.syncAnalysisSet();
        this.bindRouteChanges();
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private applyAccessSession() {
        if (this.service.auth.check()) return;
        this.service.auth.status = true;
        this.service.auth.session = ACCESS_USER;
    }

    private syncAnalysisSet() {
        this.analysisSetId = cellyticsCurrentAnalysisSetId();
        this.analysisSet = cellyticsAnalysisSet(this.analysisSetId) || cellyticsDefaultAnalysisSet();
    }

    private bindRouteChanges() {
        if (this.routerSub) return;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (!(event instanceof NavigationEnd)) return;
            const nextSetId = cellyticsCurrentAnalysisSetId();
            if (nextSetId === this.analysisSetId) return;
            this.syncAnalysisSet();
            await this.load();
        });
    }

    public async load() {
        this.syncAnalysisSet();
        this.loading = true;
        this.error = "";
        await this.service.render();

        try {
            const response = await fetch(cellyticsAnalysisDataUrl(this.analysisSetId), { cache: "no-cache" });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.analysis = await response.json();
            this.selectedSampleId = this.samples[0]?.id || "";
            this.selectedFilterCaseId = this.filterCases[0]?.id || "mmd_filter";
            const thresholdOption = this.thresholdAnalysis?.thresholds?.find((row: any) => Number(row.value) === Number(this.threshold));
            this.selectedThreshold = thresholdOption?.value || this.thresholdAnalysis?.thresholds?.[0]?.value || this.threshold;
        } catch (error) {
            this.error = "분석 데이터를 불러오지 못했습니다.";
        }

        this.loading = false;
        await this.service.render();
    }

    public get samples() {
        return this.analysis?.samples || [];
    }

    public get cases() {
        return this.analysis?.cases || [];
    }

    public get caseSummary() {
        return this.analysis?.caseSummary || [];
    }

    public get thresholdAnalysis() {
        return this.analysis?.mmdThresholdAnalysis || null;
    }

    public get thresholdSummaryRows() {
        return this.thresholdAnalysis?.summary || [];
    }

    public get threshold() {
        return this.analysis?.parameters?.mmdSdThreshold || 0;
    }

    public get selectedSample() {
        return this.samples.find((sample: any) => sample.id === this.selectedSampleId) || this.samples[0] || null;
    }

    private isTrustedNative(sample: any = this.selectedSample) {
        return sample?.nativeVerified === true;
    }

    public get originalCase() {
        return this.sampleCase(this.selectedSample, "original");
    }

    public get selectedFilterCase() {
        return this.sampleCase(this.selectedSample, this.selectedFilterCaseId) || this.sampleCase(this.selectedSample, "mmd_filter");
    }

    public get selectedThresholdSummary() {
        return this.thresholdSummaryRows.find((row: any) => Number(row.threshold) === Number(this.selectedThreshold)) || this.thresholdSummaryRows[0] || null;
    }

    public get selectedThresholdSampleRow() {
        return (this.selectedSample?.mmdThresholdRows || []).find((row: any) => Number(row.threshold) === Number(this.selectedThreshold)) || this.selectedSample?.mmdThresholdRows?.[0] || null;
    }

    public get filterCases() {
        return this.cases.filter((row: any) => row.mmdFilter);
    }

    public get filterSummaryRows() {
        return this.caseSummary.filter((row: any) => row.caseId?.indexOf("mmd_filter") >= 0);
    }

    public get metricRows() {
        return this.comparisonRows.filter((row: any) => row.source === "metrics");
    }

    public get metricStatRows() {
        const rows = this.metricRows.map((row: any) => {
            const baseValue = this.comparisonValue(row, this.originalCase);
            const filteredValue = this.comparisonValue(row, this.selectedFilterCase);
            const delta = this.comparisonDelta(row);
            const percent = this.comparisonDeltaPercent(row);
            return {
                ...row,
                baseValue,
                filteredValue,
                delta,
                percent,
                absPercent: percent === null || percent === undefined ? 0 : Math.abs(Number(percent)),
                directionLabel: delta > 0 ? "증가" : delta < 0 ? "감소" : "유지",
            };
        });
        const maxAbsPercent = rows.reduce((max: number, row: any) => Math.max(max, row.absPercent), 0);
        return rows.map((row: any) => ({
            ...row,
            barWidth: maxAbsPercent > 0 && row.absPercent > 0 ? Math.max(6, (row.absPercent / maxAbsPercent) * 100) : 0,
        }));
    }

    public get metricOverview() {
        const rows = this.metricStatRows;
        const validRows = rows.filter((row: any) => row.percent !== null && row.percent !== undefined);
        let maxRow: any = null;
        validRows.forEach((row: any) => {
            if (!maxRow || row.absPercent > maxRow.absPercent) maxRow = row;
        });
        const averageAbsPercent = validRows.length
            ? validRows.reduce((sum: number, row: any) => sum + row.absPercent, 0) / validRows.length
            : null;

        return {
            total: rows.length,
            increased: rows.filter((row: any) => row.delta > 0).length,
            decreased: rows.filter((row: any) => row.delta < 0).length,
            stable: rows.filter((row: any) => row.delta === 0).length,
            averageAbsPercent,
            maxLabel: maxRow?.label || "-",
            maxPercent: maxRow?.percent ?? null,
        };
    }

    public get filterOverview() {
        return {
            rejected: this.selectedFilterCase?.mmdRejected || 0,
            finalCount: this.selectedFilterCase?.finalCount || 0,
            countDelta: this.selectedFilterCase?.deltaCount || 0,
            mmdSdDelta: this.comparisonDelta(this.comparisonRows[6]),
            cspDelta: this.comparisonDelta(this.comparisonRows[11]),
        };
    }

    public sampleCase(sample: any, caseId: string) {
        return sample?.cases?.find((row: any) => row.caseId === caseId) || null;
    }

    public async selectSample(sampleId: string) {
        this.selectedSampleId = sampleId;
        await this.service.render();
    }

    public async selectFilterCase(caseId: string) {
        this.selectedFilterCaseId = caseId;
        await this.service.render();
    }

    public async selectThreshold(value: any) {
        this.selectedThreshold = Number(value);
        await this.service.render();
    }

    public thresholdSampleCount(value: any) {
        const row = (this.selectedSample?.mmdThresholdRows || []).find((item: any) => Number(item.threshold) === Number(value));
        return row?.finalCount;
    }

    public sampleActiveClass(sampleId: string) {
        if (this.selectedSampleId === sampleId) {
            return "flex items-center justify-between gap-3 rounded-lg border border-rose-500 bg-rose-50 px-3 py-2 text-left text-[13px] font-semibold text-rose-800";
        }
        return "flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[13px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public filterCaseActiveClass(caseId: string) {
        if (this.selectedFilterCaseId === caseId) {
            return "rounded-lg border border-rose-500 bg-rose-50 px-3 py-2 text-left text-[12px] font-semibold text-rose-800";
        }
        return "rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public thresholdActiveClass(value: any) {
        if (Number(this.selectedThreshold) === Number(value)) {
            return "rounded-lg border border-rose-500 bg-rose-50 px-3 py-2 text-left text-[12px] font-semibold text-rose-800";
        }
        return "rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public diagnosisClass(diagnosis: string) {
        if (diagnosis === "normal") return "rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700";
        if (diagnosis === "patient") return "rounded bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-700";
        return "rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-semibold text-gray-500";
    }

    public deltaClass(value: any) {
        if (value > 0) return "text-blue-700";
        if (value < 0) return "text-red-600";
        return "text-gray-500";
    }

    public signed(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        const numberValue = Number(value);
        const prefix = numberValue > 0 ? "+" : "";
        return `${prefix}${this.format(numberValue, digits)}`;
    }

    public format(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        return Number(value).toLocaleString("ko-KR", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    public metricValue(row: any, key: string) {
        const value = row?.metrics?.[key];
        if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
        return Number(value);
    }

    public comparisonValue(row: any, caseRow: any) {
        if (!row || !caseRow) return null;
        if (row.source === "metrics") return this.metricValue(caseRow, row.key);
        return caseRow[row.key];
    }

    public comparisonDelta(row: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const targetValue = this.comparisonValue(row, this.selectedFilterCase);
        if (baseValue === null || baseValue === undefined || targetValue === null || targetValue === undefined) return null;
        return Number(targetValue) - Number(baseValue);
    }

    public comparisonDeltaPercent(row: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const delta = this.comparisonDelta(row);
        if (!baseValue || delta === null || delta === undefined) return null;
        return (delta / Number(baseValue)) * 100;
    }

    public thresholdComparisonDelta(row: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const targetValue = this.comparisonValue(row, this.selectedThresholdSampleRow);
        if (baseValue === null || baseValue === undefined || targetValue === null || targetValue === undefined) return null;
        return Number(targetValue) - Number(baseValue);
    }

    public thresholdComparisonDeltaPercent(row: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const delta = this.thresholdComparisonDelta(row);
        if (!baseValue || delta === null || delta === undefined) return null;
        return (delta / Number(baseValue)) * 100;
    }

    public metricBarClass(row: any) {
        if (row?.delta > 0) return "bg-blue-500";
        if (row?.delta < 0) return "bg-red-500";
        return "bg-gray-300";
    }

    public metricBarStyle(row: any) {
        return {
            width: `${row?.barWidth || 0}%`,
        };
    }

    public caseImage(row: any) {
        const fullImage = row?.fullImage || (row?.caseId === "original" ? this.selectedSample?.originalFullImage : "");
        const downloadImage = row?.downloadImage || (row?.caseId === "original" ? this.selectedSample?.originalDownloadImage : "");
        return this.imageRef(
            row?.preview,
            fullImage,
            downloadImage,
            fullImage ? (row?.nativeWidth || this.selectedSample?.width) : null,
            fullImage ? (row?.nativeHeight || this.selectedSample?.height) : null,
            this.isTrustedNative(),
        );
    }

    public thresholdImage(row: any) {
        return this.imageRef(
            row?.preview,
            row?.fullImage,
            row?.downloadImage,
            row?.nativeWidth || this.selectedSample?.width,
            row?.nativeHeight || this.selectedSample?.height,
            false,
        );
    }

    private imageRef(preview: string, fullImage: string = "", downloadImage: string = "", nativeWidth: any = null, nativeHeight: any = null, trustedNative: boolean = false) {
        const resolvedPreview = preview || fullImage || downloadImage || "";
        const useNative = trustedNative && !!fullImage && !!nativeWidth && !!nativeHeight;
        const resolvedFull = useNative ? fullImage : resolvedPreview;
        const resolvedDownload = useNative ? (downloadImage || resolvedFull) : "";
        return {
            preview: resolvedPreview,
            fullImage: resolvedFull,
            downloadImage: resolvedDownload,
            nativeWidth: useNative ? nativeWidth : null,
            nativeHeight: useNative ? nativeHeight : null,
            nativeTrusted: useNative,
        };
    }

    private resolveImageInput(input: any) {
        if (typeof input === "string") return this.imageRef(input);
        return this.imageRef(
            input?.preview || input?.src || input?.source || "",
            input?.fullImage || input?.full || input?.sourceFull || "",
            input?.downloadImage || input?.download || input?.sourceDownload || "",
            input?.nativeWidth || null,
            input?.nativeHeight || null,
            input?.nativeTrusted === true,
        );
    }

    private modalFileName(title: string, src: string) {
        const ext = (src || "").split("?")[0].split(".").pop() || "jpg";
        const safeTitle = (title || "cellytics-image")
            .replace(/[^0-9A-Za-z._-]+/g, "_")
            .replace(/^_+|_+$/g, "") || "cellytics-image";
        return safeTitle.endsWith(`.${ext}`) ? safeTitle : `${safeTitle}.${ext}`;
    }

    public async openImageModal(input: any, title: string, caption: string = "") {
        const image = this.resolveImageInput(input);
        const src = image.fullImage || image.preview;
        this.imageModal = {
            src,
            preview: image.preview,
            download: image.downloadImage || "",
            filename: this.modalFileName(title, src),
            nativeWidth: image.nativeWidth,
            nativeHeight: image.nativeHeight,
            usingNative: !!image.nativeWidth && !!image.nativeHeight,
            title,
            caption,
        };
        await this.service.render();
    }

    public async closeImageModal() {
        this.imageModal = null;
        await this.service.render();
    }
}

export default PageFilteringComponent;